import { create } from "zustand";
import { UserProfileVO } from "src/models/UserProfile";

interface UserState {
  user: UserProfileVO | null;
  setUser: (user: UserProfileVO | null) => void;
  clearUser: () => void;
}

export const useUserStore = create<UserState>((set) => ({
  user: null,
  setUser: (user) => set({ user }),
  clearUser: () => set({ user: null }),
}));
